import { getAnalyticsMode } from "./consentGate";

// Must match the trackerName of the "Snowplow v3 Settings" variables in GTM,
// which owns tracker creation. Commands are addressed to the tracker for the
// current mode so a consent switch never reaches the other mode's tracker.
const TRACKER_NAMES = {
  granted: "storelocatorTracker",
  anonymous: "storelocatorAnonTracker",
};

export function snowplowCommand(command, ...args) {
  const trackerName = TRACKER_NAMES[getAnalyticsMode()];
  if (!trackerName) return;
  window.spDathic(`${command}:${trackerName}`, ...args);
}

export function trackSnowplowError(payload) {
  snowplowCommand("trackError", payload);
}
